import _classCallCheck from "/client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/client/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * Queue, for FIFO access to arbitrary objects. Intended to be a faster
 * replacement for a Javascript array.
 */
var Queue =
/*#__PURE__*/
function () {
  function Queue() {
    _classCallCheck(this, Queue);

    /**
     * First node in the tree
     */

    /**
     * Number of items in the queue
     */
    this.length = 0;
  }
  /**
   * Pushes a value into the queue.
   * @param value - Any object to push into the queue
   */


  _createClass(Queue, [{
    key: "push",
    value: function push(value) {
      var node = {
        value: value
      };
      this.last = this.last ? this.last.next = node : this.first = node;
      this.length++;
    }
    /**
     * Remove a value from the start of the queue (FIFO) and return it
     */

  }, {
    key: "shift",
    value: function shift() {
      if (this.first) {
        var value = this.first.value;
        this.first = this.first.next;

        if (! --this.length) {
          this.last = undefined;
        }

        return value;
      }
    }
  }]);

  return Queue;
}();

export { Queue as default };